<template>
  <AssayDescriptionGrid :dv="dv" :fields="fields">
    <template #screenFields>
      <FieldGrid
        class="form-fields"
        :dv="dv"
        :fields="[['screen_type', 'field_of_view']]"
      />
    </template>
  </AssayDescriptionGrid>
  <ScreenDescription :dv="dv" />
  <ImagingDimension
    v-model:z-stack="zStack"
    v-model:time-lapse="timeLapse"
    :dv="dv"
    :validation-errors="validationErrors"
  />
</template>

<script>
import { useAssayVuelidate } from '@/composables/validation/assay/useAssayValidation'
import {
  useImagingDimensionValidation,
  useChannelsValidation,
} from '@/composables/validation/assay/useImagingValidation'
import FieldGrid from '@/components/fields/FieldGrid.vue'
import AssayDescriptionGrid from '../shared/AssayDescriptionGrid.vue'
import { CUSTOM_PROPERTIES } from '../../shared/fieldConstants.js'
import ScreenDescription from './ScreenDescription.vue'
import ImagingDimension from './ImagingDimension.vue'

const fields = [
  ['name'],
  ['id'],
  ['state', 'slot:fc:is_template'],
  'slot:screenFields',
  ['imaging_method'],
  ['widget:instrumentData'],
  ['objective'],
  ['slot:fc:run_dir'],
  ['datasessions'],
  ['description'],
  CUSTOM_PROPERTIES,
  ['protocol_list'],
]

export default {
  name: 'AssayLightMicroscopyScreen',
  components: {
    FieldGrid,
    AssayDescriptionGrid,
    ScreenDescription,
    ImagingDimension,
  },
  props: {
    dv: { type: Object, required: true },
  },
  setup(props) {
    const { zStack, timeLapse, zPlanesError, timePointsError } =
      useImagingDimensionValidation(props.dv)
    const { channelsError } = useChannelsValidation(props.dv)

    const { validationErrors } = useAssayVuelidate({
      z_planes: zPlanesError,
      time_points: timePointsError,
      channels: channelsError,
    })

    return {
      fields,
      validationErrors,
      zStack,
      timeLapse,
    }
  },
}
</script>
